import { render, staticRenderFns } from "./praisePosts.vue?vue&type=template&id=d849c32c&scoped=true&"
import script from "./praisePosts.vue?vue&type=script&lang=js&"
export * from "./praisePosts.vue?vue&type=script&lang=js&"
import style0 from "./praisePosts.vue?vue&type=style&index=0&id=d849c32c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d849c32c",
  null
  
)

export default component.exports